function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { ContextRequestEvent as t } from "../context-request-event.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

var s = /*#__PURE__*/function () {
  function s(t, _s, i, h) {
    var _this = this;

    _classCallCheck(this, s);

    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = function (t, _s2) {
      _this.unsubscribe && (_this.unsubscribe !== _s2 && (_this.provided = !1, _this.unsubscribe()), _this.subscribe || _this.unsubscribe()), _this.value = t, _this.host.requestUpdate(), _this.provided && !_this.subscribe || (_this.provided = !0, _this.callback && _this.callback(t, _s2)), _this.unsubscribe = _s2;
    }, this.host = t, void 0 !== _s.context) {
      var _t$subscribe;

      var _t = _s;
      this.context = _t.context, this.callback = _t.callback, this.subscribe = (_t$subscribe = _t.subscribe) !== null && _t$subscribe !== void 0 ? _t$subscribe : !1;
    } else this.context = _s, this.callback = i, this.subscribe = h !== null && h !== void 0 ? h : !1;

    this.host.addController(this);
  }

  _createClass(s, [{
    key: "hostConnected",
    value: function hostConnected() {
      this.dispatchRequest();
    }
  }, {
    key: "hostDisconnected",
    value: function hostDisconnected() {
      this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
    }
  }, {
    key: "dispatchRequest",
    value: function dispatchRequest() {
      this.host.dispatchEvent(new t(this.context, this.t, this.subscribe));
    }
  }]);

  return s;
}();

export { s as ContextConsumer };